export default __webpack_public_path__ + "static/media/MANEJO_DE_FLOTAS_ROUTE_CENTER_IMG.b7944f19.jpg";